import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import './css/index.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import App from './App';
import store, { history } from './models/index';
import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
unregister();
